var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBici(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4576 46.3839C15.5428 46.3839 19.6652 42.2615 19.6652 37.1763C19.6652 32.0911 15.5428 27.9688 10.4576 27.9688C5.37238 27.9688 1.25 32.0911 1.25 37.1763C1.25 42.2615 5.37238 46.3839 10.4576 46.3839Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9185 46.3839C44.0037 46.3839 48.1261 42.2615 48.1261 37.1763C48.1261 32.0911 44.0037 27.9688 38.9185 27.9688C33.8333 27.9688 29.7109 32.0911 29.7109 37.1763C29.7109 42.2615 33.8333 46.3839 38.9185 46.3839Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7034 23.7832H17.9922",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6641 37.1766H24.6864L33.2042 22.9434",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2137 24.2207L10.4609 37.1758H17.1574",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1133 37.0057L32.2804 20.7417C32.0628 20.1926 32.1875 19.3743 33.125 19.0618L38.125 17.4992C39.0625 17.1868 40.1786 16.7596 40.3125 15.9368C40.4824 14.888 39.6875 13.7492 38.2146 14.151L31.5625 15.9368",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6908 37.1766L16.3203 20.4355",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2913 20.4361C10.3664 20.4361 9.61719 19.6869 9.61719 18.762C9.61719 17.8371 10.3664 17.0879 11.2913 17.0879H17.9877C18.9127 17.0879 19.6618 17.8371 19.6618 18.762C19.6618 19.6869 18.9127 20.4361 17.9877 20.4361H11.2913Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5896 35.6953C44.7126 36.1682 44.7779 36.6646 44.7779 37.1761C44.7779 38.0106 44.6038 38.8041 44.2891 39.5223",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5391 32.5723C42.9342 32.8836 42.998 32.9998 42.998 32.9998",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1776 17.1053H5.19737C4.7426 17.1053 4.375 16.6589 4.375 16.1067V4.12359C4.375 3.57137 4.7426 3.125 5.19737 3.125H18.3553C18.81 3.125 19.1776 3.57137 19.1776 4.12359V17.1053Z",
    fill: "#0098FF",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBici);
export default __webpack_public_path__ + "static/media/bici.e60cf40d049bf5eae9056e48437f2344.svg";
export { ForwardRef as ReactComponent };